// Models
import { IFilterValue } from '@/models/filters.model';

// Components
import { StyledActionsWrap } from './FilterValuesTableActionsStyles';
import { EditIcon, TrashIcon } from '@/icons';
import { StyledActionButton } from '@/components';

// Helpers
import { COLORS } from '@/theme';

type TFilterTableActions = {
  record: IFilterValue;
  onEdit: (filter: IFilterValue) => void;
  onDelete: (filter: IFilterValue) => void;
};

const FilterValuesTableActions = ({ record, onEdit, onDelete }: TFilterTableActions) => {
  return (
    <StyledActionsWrap>
      <StyledActionButton onClick={() => onEdit(record)} $color={COLORS.PALE_YELLOW}>
        <EditIcon />
      </StyledActionButton>
      <StyledActionButton $color={COLORS.RED} onClick={() => onDelete(record)}>
        <TrashIcon />
      </StyledActionButton>
    </StyledActionsWrap>
  );
};

export default FilterValuesTableActions;
